export const bankCodes = [
  {
    bank_name: "Ариг банк",
    bank_code: "210000",
    BIC_code: "ARGMNUB",
  },
  {
    bank_name: "Богд банк",
    bank_code: "380000",
    BIC_code: "BOGDMNUB",
  },
  {
    bank_name: "Голомт банк",
    bank_code: "150000",
    BIC_code: "GLMTMNUB",
  },
  {
    bank_name: "Капитрон банк",
    bank_code: "300000",
    BIC_code: "CPITMNUB",
  },
  {
    bank_name: "М Банк",
    bank_code: "390000",
    BIC_code: "MBNKMNUB",
  },
  {
    bank_name: "Төрийн банк",
    bank_code: "340000",
    BIC_code: "STBMMNUB",
  },
  {
    bank_name: "Тээвэр хөгжлийн банк",
    bank_code: "190000",
    BIC_code: "TRDMMNUB",
  },
  {
    bank_name: "Үндэсний хөрөнгө оруулалтын банк",
    bank_code: "290000",
    BIC_code: "NAIMNUB",
  },
  {
    bank_name: "Хаан банк",
    bank_code: "050000",
    BIC_code: "AGMOMNUB",
  },
  {
    bank_name: "Хас банк",
    bank_code: "320000",
    BIC_code: "CAXMNUB",
  },
  {
    bank_name: "Хөгжлийн банк",
    bank_code: "360000",
    BIC_code: "DEVBMNUB",
  },
  {
    bank_name: "Худалдаа хөгжлийн банк",
    bank_code: "040000",
    BIC_code: "TDBMMNUB",
  },
  {
    bank_name: "Чингис хаан банк",
    bank_code: "330000",
    BIC_code: "CHKHMNUB",
  },
  {
    bank_name: "Капитал банк ЭХА",
    bank_code: "030000",
    BIC_code: "INEHMNUB",
  },
  {
    bank_name: "Сангийн яам (Төрийн сан)",
    bank_code: "900000",
    BIC_code: "MOFUMNUB",
  },
  {
    bank_name: "Үнэт цаасны төвлөрсөн хадгаламжийн төв",
    bank_code: "950000",
    BIC_code: "CSDMMNUB",
  },
  {
    bank_name: "Монголын үнэт цаасны клирингийн төв",
    bank_code: "940000",
    BIC_code: "SSCHMNUB",
  },
  {
    bank_name: "Ард кредит ББСБ",
    bank_code: "520000",
    BIC_code: "ARDBMNUB",
  },
  {
    bank_name: "Дата бэйнк",
    bank_code: "550000",
    BIC_code: "DTBKMNUB",
  },
  {
    bank_name: "Инвескор Хэтэвч ББСБ",
    bank_code: "530000",
    BIC_code: "INVPMNUB",
  },
  {
    bank_name: "Мобифинанс ББСБ",
    bank_code: "500000",
    BIC_code: "MOBIMNUB",
  },
  {
    bank_name: "Хай пэймэнт солюшнс",
    bank_code: "510000",
    BIC_code: "HSPMMNUB",
  },
  {
    bank_name: "Монгол банк",
    bank_code: "010000",
    BIC_code: "BOMUMNUB",
  },
];

export const vatZeroGoods = [
  {
    id: 1,
    name: "Монгол Улсын нутаг дэвсгэрээс экспортод гаргасан, гаалийн байгууллагад мэдүүлсэн бараа",
    code: 501,
  },
  {
    id: 2,
    name: "Монгол Улсын Олон улсын гэрээнд заасны дагуу Монгол Улсаас гадаад улсад, гадаад улсаас Монгол Улс хүртэл, түүнчлэн гадаад улсаас Монгол Улсын хилээр дамжуулан бусад улсад гаргасан олон улсын зорчигч болон ачаа тээврийн үйлчилгээ",
    code: 502,
  },
  {
    id: 3,
    name: "Монгол Улсын нутаг дэвсгэрээс гадна үзүүлсэн /албан татвараас чөлөөлсөн үйлчилгээг оролцуулан/ үйлчилгээ",
    code: 503,
  },
  {
    id: 4,
    name: "Монгол Улсад оршин суугч бус этгээдэд үзүүлсэн үйлчилгээ /түүний дотор албан татвараас чөлөөлсөн үйлчилгээг оролцуулан/",
    code: 504,
  },
  {
    id: 5,
    name: "Олон улсын нислэг үйлдэж байгаа дотоодын болон гадаадын агаарын тээврийн хөлөгт үзүүлэх нислэгийн хөдөлгөөний удирдлага, техникийн болон шатахууны үйлчилгээ, цэвэрлэгээ, нислэгийн явцад нисэх бүрэлдэхүүн, зорчигчдод худалдаа, хоол, ундаагаар үйлчилсэн үйлчилгээ",
    code: 505,
  },
  {
    id: 6,
    name: "Засгийн газар, Монголбанкны захиалгаар дотоодод үйлдвэрлэсэн төрийн одон медаль, мөнгөн тэмдэгт, зоос",
    code: 506,
  },
  {
    id: 7,
    name: "Ашигт малтмалын эцсийн бүтээгдэхүүн",
    code: 507,
  },
];

export const vatFreeGoods = [
  {
    id: 1,
    name: "Хөгжлийн бэрхшээлтэй иргэний хэрэглээнд зориулсан тусгай зориулалтын хэрэгсэл, тоног төхөөрөмж, автотээврийн хэрэгсэл",
    code: 305,
  },
  {
    id: 2,
    name: "Иргэний агаарын хөлөг, хөдөлгүүр болон газар дээрх дадлагажуур, тэдгээрийн эд анги, бүрэлдэхүүн хэсэг, дэд угсралтын хэсэг, сэлбэг, тоног төхөөрөмж, холбогдох хэрэгсэл",
    code: 307,
  },
  {
    id: 3,
    name: "Орон сууцны зориулалтаар ашиглаж байгаа байр буюу түүний хэсгийг борлуулсны орлого",
    code: 308,
  },
  {
    id: 4,
    name: "Эмчилгээний зориулалтаар хэрэглэх цус, цусан бүтээгдэхүүн, эд эрхтэн",
    code: 310,
  },
  {
    id: 5,
    name: "Хийн түлш, түүний сав, тоног төхөөрөмж, тусгай зориулалтын машин механизм, техник хэрэгсэл, тоноглол",
    code: 311,
  },
  {
    id: 6,
    name: "Борлуулсан алт",
    code: 313,
  },
  {
    id: 7,
    name: "Эрдэм шинжилгээ, судалгааны ажлын туршилтын бүтээгдэхүүн",
    code: 315,
  },
  {
    id: 8,
    name: "Газар тариалан эрхлэгчийн дотооддоо тарьж борлуулсан үр тариа, төмс, хүнсний ногоо, суулгац, жимс жимсгэнэ, үйлдвэрлэсэн гурил",
    code: 318,
  },
  {
    id: 9,
    name: "Монгол Улсын нутаг дэвсгэрт үйлдвэрийн аргаар төхөөрч бэлтгэн дотооддоо борлуулсан тураг болон шулж ангилсан мах, боловсруулаагүй дотор эрхтэн, дайвар бүтээгдэхүүн",
    code: 319,
  },
  {
    id: 10,
    name: "Монгол Улсын нутаг дэвсгэрт дотоодын түүхий эдээр боловсруулан дотооддоо борлуулсан хүнсний сүү, сүүн бүтээгдэхүүн",
    code: 320,
  },
  {
    id: 11,
    name: "Валют солих үйлчилгээ",
    code: 401,
  },
  {
    id: 12,
    name: "мөнгө хүлээн авах, шилжүүлэх, баталгаа, төлбөрийн нэхэмжлэл гаргах, вексель, хадгаламжийн данстай холбогдсон банкны үйлчилгээ",
    code: 402,
  },
  {
    id: 13,
    name: "Даатгал, даатгалын зуучлал, давхар даатгал, эд хөрөнгийн бүртгэлийн үйлчилгээ",
    code: 403,
  },
  {
    id: 14,
    name: "Үнэт цаас, хувьцаа гаргах, шилжүүлэх, борлуулах, хүлээн авах, тэдгээрт баталгаа гаргах үйлчилгээ",
    code: 404,
  },
  {
    id: 15,
    name: "Зээл олгох үйлчилгээ",
    code: 405,
  },
  {
    id: 16,
    name: "Нийгмийн болон эрүүл мэндийн даатгалын сангийн мөнгөн хөрөнгийг байршуулсны хүүг олгох, шилжүүлэх үйлчилгээ",
    code: 406,
  },
  {
    id: 17,
    name: "Банкны болон банк бус санхүүгийн байгууллага, хадгаламж зээлийн хоршооны зээлийн хүү, Аж ахуйн нэгжийн орлогын албан татварын тухай хуулийн 9.4-т заасан хүү, 10.1.3-т заасан хувьцаа, үнэт цаас, санхүүгийн бусад хэрэгсэл, санхүүгийн түрээсийн хүү, ногдол ашиг, зээлийн баталгааны хураамж, даатгалын гэрээний хураамж төлөх үйлчилгээ",
    code: 407,
  },
  {
    id: 18,
    name: "Орон сууцны зориулалтаар баригдсан зориулалтын дагуу ашиглагдаж байгаа байрыг болон түүний тодорхой хэсгийг хөлслүүлэх үйлчилгээ",
    code: 408,
  },
  {
    id: 19,
    name: "Боловсролын болон мэргэжлийн сургалт явуулах зөвшөөрөлтэй хувь хүн, хуулийн этгээдийн эрхлэн гүйцэтгэж байгаа дүрэмд нь заасан боловсрол, мэргэжил олгох үйлчилгээ",
    code: 409,
  },
  {
    id: 20,
    name: "Эрүүл мэндийн үйлчилгээ",
    code: 410,
  },
  {
    id: 21,
    name: "Шашны байгууллагын үйлчилгээ",
    code: 411,
  },
  {
    id: 22,
    name: "Төрийн байгууллагаас үзүүлж байгаа үйлчилгээ. Үүнд Засгийн газар, түүний агентлагууд, төсөвт байгууллагуудаас үзүүлж байгаа төрийн үйлчилгээ хамаарна",
    code: 412,
  },
  {
    id: 23,
    name: "Автотээврийн тухай хуулийн[6] 3.1.11-д заасан нийтийн тээврийн үйлчилгээ",
    code: 413,
  },
  {
    id: 24,
    name: "Тур оператор, аяллын агент гадаад улсын аялал жуулчлалын байгууллагатай гэрээ байгуулж жуулчдыг нь хүлээн авах, уг үйлчилгээг төлөвлөх, сурталчлах, виз авахтай холбогдсон болон аяллын бусад бичиг баримтын бүрдүүлэлт хийх зэрэг гадаадын жуулчинд үзүүлсэн үйлчилгээ",
    code: 414,
  },
  {
    id: 25,
    name: "Монгол Улсын нутаг дэвсгэрт үйлдвэрлэсэн, үйлдвэрлэн борлуулсан жижиг, дунд үйлдвэрийн үйлдвэрлэлийн зориулалт бүхий тоног төхөөрөмж, сэлбэг хэрэгсэл",
    code: 419,
  },
  {
    id: 26,
    name: "НӨАТ тухай хуулийн 12.1.7-д зааснаас бусад экспортод гаргасан ашигт малтмалын бүтээгдэхүүн",
    code: 421,
  },
  {
    id: 27,
    name: "Инновацийн төслөөр дотоод, гадаадын зах зээлд шинэ бараа, бүтээгдэхүүний үйлдвэрлэл явуулахад шаардлагатай, дотоодод үйлдвэрлэдэггүй түүхий эд, материал, урвалж бодис",
    code: 423,
  },
  {
    id: 28,
    name: "Экспортод гаргасан түүхий болон угаасан, самнасан ноолуур, арьс шир",
    code: 425,
  },
  {
    id: 29,
    name: "Соёлын өвийг судалж шинжлэх, сэргээн засварлахад ашиглах материал, техник, тоног төхөөрөмж, бодис, багаж хэрэгсэл",
    code: 426,
  },
  {
    id: 30,
    name: "Газрын тос болон уламжлалт бус газрын тостой холбогдсон тайлан материал, дээж болон газрын тос",
    code: 428,
  },
  {
    id: 31,
    name: "Чөлөөт бүсэд зорчигчийн худалдаж авсан гурван сая төгрөг хүртэл үнийн дүнтэй бараа",
    code: 429,
  },
  {
    id: 32,
    name: "Соёлын өвийг сэргээн засварлах үйлчилгээ",
    code: 430,
  },
  {
    id: 33,
    name: "Оршуулгын үйлчилгээ",
    code: 431,
  },
  {
    id: 34,
    name: "Сэргээгдэх эрчим хүчний судалгаа шинжилгээний болон үйлдвэрлэлийн тоног төхөөрөмж, түүний дагалдах хэрэгсэл, сэлбэг.",
    code: 433,
  },
  {
    id: 35,
    name: "Импортоор оруулж байгаа болон дотооддоо худалдан борлуулсан хөдөө аж ахуйн зориулалттай шинэ трактор, комбайн, машин механизм, гурилын болон бордооны үйлдвэрийн тоног төхөөрөмж, усалгааны тоног төхөөрөмж, ойн аж ахуйн техник, тоног төхөөрөмж, бордоо, ургамал хамгааллын бодис",
    code: 434,
  },
  {
    id: 36,
    name: "Мал эмнэлэгийн үйлчилгээ",
    code: 436,
  },
  {
    id: 37,
    name: "Нотариатын үйлчилгээ",
    code: 437,
  },
  {
    id: 38,
    name: "“Таван толгой түлш” ХХК-ийн үйлдвэрлэсэн сайжруулсан шахмал түлш",
    code: 439,
  },
  {
    id: 39,
    name: "Үнэт цаасны зах зээлийн тухай хуулийн 4.1.6-д заасан санхүүгийн хэрэгслийг анхдагч, хоёрдогч зах зээл болон биржийн бус зах зээлд бүртгүүлэх, гаргах, арилжих, шилжүүлэх, борлуулах, хүлээн авах, хадгалах үйл ажиллагаа болон тэдгээрт баталгаа гаргах үйлчилгээ;",
    code: 438,
  },
  {
    id: 40,
    name: "банк, банк бус санхүүгийн байгууллага болон бусад хуулийн этгээдээс банк, тусгай зориулалтын компани, орон сууцны санхүүжилтийн компанид хөрөнгөөр баталгаажсан үнэт цаас гаргах зориулалтаар шилжүүлсэн зээл, санхүүгийн түрээсийн гэрээнээс үүсэх аливаа шаардах эрх;",
    code: 316,
  },
  {
    id: 41,
    name: "Ирээдүйн өв санд улсын төсвөөс хуваарилсан орлого эх үүсвэр, сангийн хөрөнгө оруулалтын орлого",
    code: 443,
  },
  {
    id: 42,
    name: "Шинээр үйлдвэрлэсэн инновацийн бүтээгдэхүүн, ажил үйлчилгээ",
    code: 444,
  },
  {
    id: 43,
    name: "Виртуал хөрөнгийн үйлчилгээ",
    code: 445,
  },
  {
    id: 44,
    name: "Малчин, мал бүхий этгээдийн борлуулсан таван хошуу мал, анхан шатны боловсруулалтад ороогүй мах, сүү, арьс шир, ноолуур, хонь болон тэмээний ноос, сарлагийн хөөвөр",
    code: 447,
  },
];
